define("TavanoTeam.TTPDPLeadTime.Request.View",
  [
    "tavanoteam_leadtime_request.tpl",
    "Utils",
    "Backbone",
    "Backbone.FormView",
    "Backbone.CompositeView",
    "Tavano.TTPDPLeadTime.TTPDPLeadTime.Model",
    "TavanoTeam.TTPDPLeadTime.Confirmation.View",
    "jQuery",
    "underscore"
  ],
  function (
    tavanoteam_request_tpl,
    Utils,
    Backbone,
    BackboneFormView,
    BackboneCompositeView,
    LeadTimeModel,
    LeadTimeConfirmationView,
    jQuery,
    _
  ) {
    "use strict";

    return Backbone.View.extend({
      template: tavanoteam_request_tpl,
      bindings: {
        '[name="quantity"]': "quantity",
        '[name="zip"]': "zip",
        '[name="email"]': "email",
        '[name="full_name"]': "full_name",
        '[name="last_name"]': "last_name",
        '[name="role"]': "role",
        '[name="phone_number"]': "phone_number"
      },
      events: {
        "submit form": "saveForm",
        'input [name="phone_number"]': "onPhoneInput"
      },
      onPhoneInput: function onPhoneInput(event) {
        var input = event.currentTarget;
        var digits = input.value.replace(/\D/g, "").slice(0, 10);
        var formatted = "";

        if (digits.length > 0) {
          if (digits.length <= 3) {
            formatted = "(" + digits;
          } else if (digits.length <= 6) {
            formatted =
              "(" + digits.substring(0, 3) + ") " + digits.substring(3, digits.length);
          } else if (digits.length <= 7) {
            formatted =
              digits.substring(0, 3) + "-" + digits.substring(3, digits.length);
          } else {
            formatted =
              "(" +
              digits.substring(0, 3) +
              ") " +
              digits.substring(3, 6) +
              "-" +
              digits.substring(6, digits.length);
          }
        }

        input.value = formatted;
        this.model.set("phone_number", formatted, { silent: true });
      },
      initialize: function (options) {
        BackboneCompositeView.add(this);
        this.model = new LeadTimeModel();
        BackboneFormView.add(this);
        this.model.on("sync", jQuery.proxy(this, "manageResponse"));
      },

      manageResponse: function manageResponse(model) {
        if (model.get("status") == "fail") {
          this.showError();
        } else {
          this.showSuccess();
        }
      },
      showSuccess: function showSuccess() {
        var layout = this.options.layout;
        var confirmationView = new LeadTimeConfirmationView({
          isConfirmation: true
        });
        layout.showInModal(confirmationView, {});
      },
      showError: function showError() {
        var layout = this.options.layout;
        var confirmationView = new LeadTimeConfirmationView({
          isConfirmation: false
        });
        layout.showInModal(confirmationView, {});
      },

      getContext: function getContext() {
        return {
          item: this.options.item.internalid,
          itemid: this.options.item.itemid
        };
      }
    });
  });
